// 见 zh-CN.ts 里的说明：umi 只认单文件 locale，分模块词典放 src/dict/ 后在此汇总。
import menu from '@/dict/en-menu';
import common from '@/dict/en-common';
import page from '@/dict/en-page';
import page2 from '@/dict/en-page2';
import page3 from '@/dict/en-page3';
import page4 from '@/dict/en-page4';

export default {
  ...menu,
  ...common,
  ...page,
  ...page2,
  ...page3,
  ...page4,
};
